import {React, useEffect, useState, useRef} from 'react';
import useHorizontalScroll from './useHorizontalScroll';
import Image4 from '../images/image4.webp';
import Image5 from '../images/image5.webp';
import Image6 from '../images/image6.webp';
import Image7 from '../images/image7.webp';
import Image89 from '../images/image89.webp';
import Image91 from '../images/image91.webp';
import { useNavigate } from "react-router-dom";
import { GiPalmTree } from "react-icons/gi";
import { TbShieldCheckFilled } from "react-icons/tb";
import '../App.css';
import './testimonials.css';


const testimonialsData = [
	{
	  name: 'Michael B',
	  review: 'Sam’s Tree Service did an amazing job! Highly recommend.',
	  image: Image4, 
	},
	{
	  name: 'Mrs Tran',
	  review: 'Affordable and professional service. My yard looks great!',
	  image: Image5,
	},
	{
	  name: 'Denies H',
	  review: 'Quick and efficient! The team was courteous and clean.',
	  image: Image6,
	},
	{
	  name: 'Marilyn Neil',
	  review: 'They removed a dangerous tree with precision and care.',
	  image: Image7,
	},

	{
		name: 'Wendy Sestito',
		review: 'When I got home from work the trees were done and you would have never know they were here.',
		image: Image91,
	  },

	  {
		name: 'Rick Butera',
		review: 'I was truly impressed by their work ethics.',
		image: Image89,
	  },
  ];

const Testimonials = () => {
		const { scrollRef, scrollLeft, scrollRight } = useHorizontalScroll();
		const [count, setCount] = useState(0);
		const [percentage, setPercentage] = useState(0);
		const [experience, setExperience] = useState(0); 
		const ref = useRef(null);
		const ref2 = useRef(null);
		const ref3 = useRef(null);
		const navigate = useNavigate(); 

		  const handleNavigation2 = () => {
			navigate("/reviews"); // Replace with your target page route
		  }; 
		  
		  
useEffect(() => {
			// Set up the intersection observer for the first element (reviews)
			const observer = new IntersectionObserver(
			  (entries) => {
				entries.forEach(({ isIntersecting, target }) => {
				  if (isIntersecting) {
					if (target === ref.current) {
					  let start = 0;
					  const end = 100;
					  const duration = 2000;
					  const stepTime = 10;
					  const increment = (end - start) / (duration / stepTime);
		
					  const timer = setInterval(() => {
						start += increment;
						if (start >= end) {
						  start = end;
						  clearInterval(timer);
						}
						setCount(Math.floor(start));
					  }, stepTime);
					}
				  }
				});
			  },
			  { threshold: 0.5 }
			);
		
			if (ref.current) observer.observe(ref.current);
		
			return () => {
			  if (ref.current) observer.unobserve(ref.current);
			};
		  }, []);
		
		  useEffect(() => {
			// Set up the intersection observer for the second element (satisfaction percentage)
			const observer2 = new IntersectionObserver(
			  (entries) => {
				entries.forEach(({ isIntersecting, target }) => {
				  if (isIntersecting) {
					if (target === ref2.current) {
					  let start = 0;
					  const end = 100;
					  const duration = 2000;
					  const stepTime = 10;
					  const increment = (end - start) / (duration / stepTime);
		
					  const timer = setInterval(() => {
						start += increment;
						if (start >= end) {
						  start = end;
						  clearInterval(timer);
						}
						setPercentage(Math.floor(start));
					  }, stepTime);
					}
				  }
				});
			  },
			  { threshold: 0.5 }
			);
		
			if (ref2.current) observer2.observe(ref2.current);
		
			return () => {
			  if (ref2.current) observer2.unobserve(ref2.current);
			};
		  }, []);
		
		  useEffect(() => {
			// Set up the intersection observer for the third element (years of experience)
			const observer3 = new IntersectionObserver(
			  (entries) => {
				entries.forEach(({ isIntersecting, target }) => {
				  if (isIntersecting) {
					if (target === ref3.current) {
					  let start = 0;
					  const end = 10;
					  const duration = 2000;
					  const stepTime = 10;
					  const increment = (end - start) / (duration / stepTime);
		
					  const timer = setInterval(() => {
						start += increment;
						if (start >= end) {
						  start = end;
						  clearInterval(timer);
						}
						setExperience(Math.floor(start));
					  }, stepTime);
					}
				  }
				});
			  },
			  { threshold: 0.5 }
			);
		
			if (ref3.current) observer3.observe(ref3.current);
		
			return () => {
			  if (ref3.current) observer3.unobserve(ref3.current);
			};
		  }, []);

		  

	return (
		<div id="testimonials_module9">
						
						<div id='testimonials_title9'>
						<div id='icon_four29'>
							<div id='four_text2_19'><h1> - - - - - -&nbsp;&nbsp;</h1></div>
							<div id='icon_four_icon29'><GiPalmTree /></div>
							<div id='four_text2_29'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
						</div>
						<div id='testimonials_title_sub9'>
							<h1>Real Feedback, Real Results</h1>
						</div>
						</div>
					  <div className="testimonials-container9">
						<button className="scroll-btn left" onClick={() => scrollLeft()}>
							&larr;
						 </button>
					  <div className="testimonials-wrapper9" ref={scrollRef}>
						  {testimonialsData.map((testimonial, index) => (
					  <div className="testimonial-box9" key={index}
							>
						<img
							src={testimonial.image}
							alt={`Testimonial from ${testimonial.name}`}
							className="testimonial-image9"
							style={{ padding: '0', margin: '0' }}
						/>
						<p className="review9">"{testimonial.review}"</p>
						<h3 className="customer-name9">- {testimonial.name}</h3>
					  </div>
						))}
					  </div>
						<button className="scroll-btn right" onClick={() => scrollRight()}>
							&rarr;
						</button>
					 </div>
		
						<div id='reviewlink_index9' 
							onClick={handleNavigation2}
							>More Reviews
						</div>
		
					 <div id='modulesix_pic29'>
								<div id='mod619' className='mod6_widgits9'>
									<div className='Mod6_widget_text9' id='Mod6_text19'>
										<div className='icon-wood_widget_div9' ><TbShieldCheckFilled className="icon-wood_widget9"/></div>
										<div className='icon-wood_widget_div_sub9'ref={ref}><h1>{count}+</h1><p>Five-Star Reviews</p></div>
									</div>
								</div>
								<div  id='mod629' className='mod6_widgits'>
									<div className='Mod6_widget_text9' id='Mod6_text29'>
										<div className='icon-wood_widget_div9' ><TbShieldCheckFilled className="icon-wood_widget9"/></div>
										<div className='icon-wood_widget_div_sub9' ref={ref2}><h1>{percentage}%</h1><p>Satisfaction Guaranteed</p></div>
									</div>
								</div>
								<div  id='mod639' className='mod6_widgits9'>
									<div className='Mod6_widget_text9' id='Mod6_text39'>
										<div className='icon-wood_widget_div9' ><TbShieldCheckFilled className="icon-wood_widget9"/></div>
										<div className='icon-wood_widget_div_sub9' ref={ref3}><h1>{experience}+</h1><p>Years of Experience</p></div>
									</div>
								</div>
								<div  id='mod649' className='mod6_widgits9'>
									<div className='Mod6_widget_text9' id='Mod6_text49'>
										<div className='icon-wood_widget_div9' ><TbShieldCheckFilled className="icon-wood_widget9"/></div>
										<div className='icon-wood_widget_div_sub9'><h1>A +</h1><p>BBB Rating</p></div>
									</div>
								</div>
						
						</div>
					</div>
	);
};

export default Testimonials;